module.exports = __webpack_public_path__ + "static/media/aeronave.b4b5bc09.glb";